import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { Icon } from 'react-native-elements'
import { TouchableOpacity } from 'react-native-gesture-handler'
import colors from '../styles/colors'
import spacing from '../styles/spacing'
import MSFESButton from './MSFESButton'

const BannerWithButton = ({
  buttonTitle,
  onDismiss = null,
  children,
  style,
  onPress
}) => {
  return (
    <View style={[styles.notificationBar, style]}>
      <View style={{ flex: 1, justifyContent: 'center' }}>
        <Text style={styles.notificationBarHeading}>{children}</Text>
      </View>
      {!!buttonTitle && !!onPress && (
        <MSFESButton
          small
          variant="outline"
          title={buttonTitle}
          containerStyle={{ padding: 0 }}
          onPress={onPress}
        />
      )}
      {onDismiss && (
        <TouchableOpacity
          onPress={onDismiss}
          style={{ paddingLeft: spacing.m2 }}
        >
          <Icon
            type="font-awesome"
            name="times"
            size={16}
            color={colors.blueDarkest}
          />
        </TouchableOpacity>
      )}
    </View>
  )
}

export default BannerWithButton

const styles = StyleSheet.create({
  notificationBar: {
    paddingHorizontal: spacing.m2,
    paddingVertical: spacing.m1,
    backgroundColor: colors.lighterGray,
    flexDirection: 'row'
    // alignItems:"center"
  },
  notificationBarHeading: {
    color: colors.blueDarkest,
    fontSize: 16,
    fontWeight: 'bold'
  },
  view: {
    paddingHorizontal: spacing.m2,
    paddingVertical: spacing.m1,
    backgroundColor: colors.lighterGray
  },
  text: {},
  textDate: {
    fontSize: 10
  },
  heading: {
    fontSize: 16,
    fontWeight: 'bold'
  }
})
